import { BorderRadiusKeys, BorderStyles, TypographyKeys } from './global-styling.enum';
import { Constants } from './workflow-constants.type';

export const defaultFilterPillsConfig = {
  isEnabled: false,
  globalStyling: true,
  borderConfig: {
    'border-left-width': '1px',
    'border-right-width': '1px',
    'border-top-width': '1px',
    'border-bottom-width': '1px',
    'border-top-left-radius': '20px',
    'border-bottom-left-radius': '20px',
    'border-top-right-radius': '20px',
    'border-bottom-right-radius': '20px',
    borderRadiusClass: BorderRadiusKeys.NONE,
    borderStyle: BorderStyles.SOLID,
  },
  css_config: {
    ...Constants.defaultBaseCssConfig,
    textAlignment: 'start',
    verticalAlignment: 'center',
    textFont: 'Mulish',
    fontSize: 14,
    shadowBlur: 0,
    shadowSpread: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: '#000000',
    fontWeight: '400',
    color: 'var(--color-primary)',
    marginTop: 0,
    marginRight: 8,
    marginLeft: 8,
    marginBottom: 0,
    marginUnit: 'px',
    paddingRight: 12,
    paddingLeft: 12,
    paddingUnit: 'px',
    height: 36,
    dimensionUnit: 'px',
  },
  colorConfig: {
    idle: {
      textColor: {
        color: 'var(--color-on-background)',
      },
      labelColor: {
        color: 'var(--color-on-background)',
      },
      'border-color': '#EDEDED',
      'background-color': '#EDEDED',
    },
    active: {
      textColor: {
        color: 'var(--color-primary)',
      },
      labelColor: {
        color: 'var(--color-primary)',
      },
      'border-color': 'var(--color-primary)',
      'background-color': '#E1EAFF',
    },
  },
  textStyleClass: TypographyKeys.LABEL_TEXT,
  iconConfig: {
    icon: 'alert-error-icon',
    css_config: {
      marginLeft: 6,
      marginRight: 10,
      marginUnit: 'px',
      iconSize: 14,
      iconUnit: 'px',
      iconColor: 'var(--color-primary)',
    },
  },
};
